module.exports = __webpack_public_path__ + "assets/img/3.32c54e43.jpg";